module.exports = __webpack_public_path__ + "img/threats-ai-suggestions.d2ee93d5.png";